import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { Instagram } from 'lucide-react';
const categories = ['🌙 Patio', '🔥 Parrilla', '🥪 Comidas', '🍹 Tragos', '☕ Allegra', '🎶 Shows', '👨‍👩‍👧 Ambiente'];
const galleryImages = [
// Patio - 3 images
{
  id: 1,
  src: 'https://cdn.magicpatterns.com/uploads/ugdRz2ESaAEEr5pvvv4Pyr/patio_1.jpg',
  category: '🌙 Patio',
  alt: 'Patio El Matambrito 1'
}, {
  id: 2,
  src: 'https://cdn.magicpatterns.com/uploads/vuwygRpHUGLQqmTydJxaWB/patio_2.jpg',
  category: '🌙 Patio',
  alt: 'Patio El Matambrito 2'
}, {
  id: 3,
  src: 'https://cdn.magicpatterns.com/uploads/a8cH4pxQKNQz2Vg1v9E2mc/patio_3.jpg',
  category: '🌙 Patio',
  alt: 'Patio El Matambrito 3'
},
// Parrilla - 3 images
{
  id: 4,
  src: 'https://cdn.magicpatterns.com/uploads/kgDhcY2AxDGiGsF736dPbt/WhatsApp_Image_2026-04-14_at_16.23.43.jpg',
  category: '🔥 Parrilla',
  alt: 'Parrilla 1'
}, {
  id: 5,
  src: 'https://cdn.magicpatterns.com/uploads/3TPCXgUXYVK4VG9TaJWnL4/gallery-parrilla-2.jpg',
  category: '🔥 Parrilla',
  alt: 'Parrilla 2'
}, {
  id: 6,
  src: 'https://cdn.magicpatterns.com/uploads/5EiLmJZZ4Zs9bpvdV7e6Dg/parrilla_3.jpg',
  category: '🔥 Parrilla',
  alt: 'Parrilla 3'
},
// Comidas - 3 images
{
  id: 7,
  src: 'https://cdn.magicpatterns.com/uploads/q1cnDLSXhrzCMPyAtefEYp/comidas_1.jpg',
  category: '🥪 Comidas',
  alt: 'Comidas 1'
}, {
  id: 8,
  src: 'https://cdn.magicpatterns.com/uploads/1ragtZ1jwhMVdQcowTgNGw/comidas_2.jpg',
  category: '🥪 Comidas',
  alt: 'Comidas 2'
}, {
  id: 9,
  src: 'https://cdn.magicpatterns.com/uploads/d8YcY9Y3SwHJhMAJpQRkf5/comidas_3.jpg',
  category: '🥪 Comidas',
  alt: 'Comidas 3'
},
// Tragos - 3 images
{
  id: 10,
  src: 'https://cdn.magicpatterns.com/uploads/7DKe9z3bHeGPN7vBZuCBXC/tragos_1.jpg',
  category: '🍹 Tragos',
  alt: 'Tragos 1'
}, {
  id: 11,
  src: 'https://cdn.magicpatterns.com/uploads/t7ZeJq3iixAfRVvr8eg1Nm/tragos_2.jpg',
  category: '🍹 Tragos',
  alt: 'Tragos 2'
}, {
  id: 12,
  src: 'https://cdn.magicpatterns.com/uploads/qMM1d9NMPKyUhZy8RCZ6f8/tragos_3.jpg',
  category: '🍹 Tragos',
  alt: 'Tragos 3',
  objectPosition: 'bottom'
},
// Allegra - 3 images
{
  id: 13,
  src: 'https://cdn.magicpatterns.com/uploads/numqRhzaTrP9SXnppJCCak/allegra_1.jpg',
  category: '☕ Allegra',
  alt: 'Allegra Café - Postres'
}, {
  id: 14,
  src: 'https://cdn.magicpatterns.com/uploads/9idT2L5xVoD9gEaDEPTXeB/allegra_2.jpg',
  category: '☕ Allegra',
  alt: 'Allegra Café - Merienda'
}, {
  id: 15,
  src: 'https://cdn.magicpatterns.com/uploads/cqHnRsm5ibShkQmegiWWFC/allegra_3.jpg',
  category: '☕ Allegra',
  alt: 'Allegra Café - Espacio',
  objectPosition: 'top'
},
// Shows - 3 images
{
  id: 16,
  src: 'https://cdn.magicpatterns.com/uploads/2nyJg65nnQbaGWQWZJWaiL/shows_1.jpg',
  category: '🎶 Shows',
  alt: 'Shows - Folclore en vivo'
}, {
  id: 17,
  src: 'https://cdn.magicpatterns.com/uploads/pKK8UsB65vfrC7EMmKiSUH/shows_2.jpg',
  category: '🎶 Shows',
  alt: 'Shows - Mimo y niños',
  objectPosition: 'top'
}, {
  id: 18,
  src: 'https://cdn.magicpatterns.com/uploads/ruTerRfGArgi3bh3tFyE6i/shows_3.jpg',
  category: '🎶 Shows',
  alt: 'Shows - Grupo folclórico',
  objectPosition: 'top'
},
// Ambiente - 3 images
{
  id: 19,
  src: 'https://cdn.magicpatterns.com/uploads/iLrrhpVahLNjVK3UWtnCA4/gallery-ambiente-2.jpg',
  category: '👨‍👩‍👧 Ambiente',
  alt: 'Ambiente - Patio de noche'
}, {
  id: 20,
  src: 'https://cdn.magicpatterns.com/uploads/cMzEZcdXgUCn6xBdG2j5dS/ambiente_2.jpg',
  category: '👨‍👩‍👧 Ambiente',
  alt: 'Ambiente - Noche con luces'
}, {
  id: 21,
  src: 'https://cdn.magicpatterns.com/uploads/x2R1QfiKkbkfMeFzYxyDhE/ambiente_3.jpg',
  category: '👨‍👩‍👧 Ambiente',
  alt: 'Ambiente - Familias disfrutando'
}];
export function Gallery() {
  const [activeFilter, setActiveFilter] = useState(categories[0]);
  const filteredImages = galleryImages.filter(img => img.category === activeFilter);
  return <section id="galeria" className="py-24 bg-matambrito-black relative" data-id="element-245">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-246">
        <div className="text-center max-w-3xl mx-auto mb-12" data-id="element-247">
          <motion.h2 initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="text-3xl md:text-4xl lg:text-5xl font-serif font-bold text-matambrito-cream mb-4" data-id="element-248">
            Así se vive{' '}
            <span className="text-matambrito-gold" data-id="element-249">El Matambrito</span>
          </motion.h2>
          <motion.p initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.1
        }} className="text-xl text-matambrito-beige font-light" data-id="element-250">
            Cada foto cuenta lo que las palabras no alcanzan.
          </motion.p>
        </div>

        {/* Filters */}
        <div className="flex flex-wrap justify-center gap-2 mb-12" data-id="element-251">
          {categories.map(category => <button key={category} onClick={() => setActiveFilter(category)} className={`px-4 py-2 rounded-full text-sm font-medium transition-all duration-300 ${activeFilter === category ? 'bg-matambrito-gold text-matambrito-black shadow-[0_0_15px_rgba(255,215,0,0.3)]' : 'bg-matambrito-charcoal text-matambrito-beige hover:bg-white/10 border border-white/5'}`} data-id="element-252">
              {category}
            </button>)}
        </div>

        {/* Grid */}
        <div className="min-h-[400px]" data-id="element-253">
          <AnimatePresence mode="wait" data-id="element-254">
            <motion.div key={activeFilter} initial={{
            opacity: 0,
            y: 20
          }} animate={{
            opacity: 1,
            y: 0
          }} exit={{
            opacity: 0,
            y: -20
          }} transition={{
            duration: 0.3
          }} className="grid grid-cols-1 md:grid-cols-3 gap-4 auto-rows-[250px]" data-id="element-255">
              {filteredImages.map(image => <div key={image.id} className="relative rounded-xl overflow-hidden group" data-id="element-256">
                  <img src={image.src} alt={image.alt} className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-110" style={image.objectPosition ? {
                objectPosition: image.objectPosition
              } : undefined} data-id="element-257" />
                  <div className="absolute inset-0 bg-black/50 opacity-0 group-hover:opacity-100 transition-opacity duration-300 flex items-center justify-center" data-id="element-258">
                    <span className="text-white font-medium px-4 py-2 border border-white/30 rounded-full backdrop-blur-sm" data-id="element-259">
                      {image.category}
                    </span>
                  </div>
                </div>)}
            </motion.div>
          </AnimatePresence>
        </div>

        {/* Bottom CTA */}
        <div className="mt-16 text-center" data-id="element-260">
          <p className="text-matambrito-beige mb-6 text-lg" data-id="element-261">
            ¿Querés ver más? Seguinos en Instagram
          </p>
          <a href="https://instagram.com/elmatambritovgg" target="_blank" rel="noopener noreferrer" className="inline-flex items-center gap-2 bg-gradient-to-r from-[#833ab4] via-[#fd1d1d] to-[#fcb045] text-white px-8 py-3 rounded-md font-medium transition-all hover:opacity-90 hover:scale-105 shadow-lg" data-id="element-262">
            <Instagram className="w-5 h-5" data-id="element-263" />
            @elmatambritovgg
          </a>
        </div>
      </div>
    </section>;
}